import { useEffect, useState } from "react";

const numberOnly = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

function truncateText(text) {
  if (text?.length > 80) {
    return `${text.substring(0, 80)} ..... `;
  } else {
    return text.substring(0, 80);
  }
}
function truncateWords(str, limit = 100) {
  const words = str.split(" ");
  let truncated = "";
  for (let word of words) {
    if ((truncated + word).length <= limit) {
      truncated += word + " ";
    } else {
      break;
    }
  }
  return truncated.trim() + (truncated.length < str.length ? "..." : "");
}

const uniqueIdGenerator = function () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
const multiSelectCustomStyle = {
  control: (base) => ({
    ...base,
    zIndex: 0,
    padding: "5px",
    border: "1.5px solid #c9ccd0",
    boxShadow: "none !important",
    "*": {
      boxShadow: "none !important",
    },
    "&:hover": {
      border: "1.5px solid #e0e0e0 !important",
    },
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "14px",
    color: "#dbdbdb",
  }),
};
const ScoutingFiledProcessData = (data) => {
  return data
    ?.map((field) => {
      if (field.type === 1) {
        return {
          _id: field._id,
          name: field.name,
          cropName: field.subfield.length > 0 ? field.subfield[0].cropName : "",
          cropId: field.subfield.length > 0 ? field.subfield[0].cropId : "",
          area: field.area,
          lld1: field?.lld1,
          lld2: field?.lld2,
          lld3: field?.lld3,
          lld4: field?.lld4,
          lld5: field?.lld5,
          lld6: field?.lld6,
          notes: field.notes,
          updatedAt: field.updatedAt,
          isActive: field?.isActive,
          subfield: [],
        };
      } else if (field.type === 2) {
        // If type is 2, format the data with the specific structure for type 2
        return {
          _id: field._id,
          name: field.name,
          area: field.area,
          type: field.type,
          lld1: field?.lld1,
          lld2: field?.lld2,
          lld3: field?.lld3,
          lld4: field?.lld4,
          lld5: field?.lld5,
          lld6: field?.lld6,
          notes: field.notes,
          updatedAt: field.updatedAt,
          subfield: field.subfield.map((sub) => ({
            _id: sub._id,
            name: sub.name,
            cropId: sub.cropId,
            updatedAt: sub.updatedAt,
            cropName: sub.cropName,
          })),
        };
      }
      return null;
    })
    .filter((item) => item !== null);
};
const FiledProcessData = (data) => {
  return data
    ?.map((field) => {
      if (field.type === 1) {
        return {
          _id: field._id,
          name: field.name,
          // cropName: field.subfield.length > 0 ? field.subfield[0].cropName : "",
          // cropId: field.subfield.length > 0 ? field.subfield[0].cropId : "",
          area: field.area,
          lld1: field?.lld1,
          lld2: field?.lld2,
          lld3: field?.lld3,
          lld4: field?.lld4,
          lld5: field?.lld5,
          lld6: field?.lld6,
          notes: field.notes,
          updatedAt: field.updatedAt,
          subFields: [],
          seasons: field.seasons.map((season) => ({
            seasonId: season.seasonId,
            year: season.seasonYear,
          })),
          cropData: field.cropData.map((year) => ({
            cropId: year.cropId,
            seasonId: year.seasonId,
            cropName: year?.cropName,
            _id: year?._id,
          })),
        };
      } else if (field.type === 2) {
        // If type is 2, format the data with the specific structure for type 2
        return {
          _id: field._id,
          name: field.name,
          area: field.area,
          type: field.type,
          lld1: field?.lld1,
          lld2: field?.lld2,
          lld3: field?.lld3,
          lld4: field?.lld4,
          lld5: field?.lld5,
          lld6: field?.lld6,
          notes: field.notes,
          updatedAt: field.updatedAt,
          subFields: field.subfield.map((sub) => ({
            _id: sub._id,
            name: sub.name,
            cropId: sub.cropId,
            updatedAt: sub.updatedAt,
            cropName: sub.cropName,
          })),
          seasons: field.seasons.map((season) => ({
            seasonId: season.seasonId,
            year: season.year,
          })),
        };
      }
      return null;
    })
    .filter((item) => item !== null);
};
// const scoutingProcessData = (data) => {
//   if (!Array.isArray(data)) return []; // Ensure input is an array

//   return data
//     .map((item) => {
//       const field = item.fieldDetails;
//       if (!field) return null; // Skip if fieldDetails is missing

//       // Common structure
//       const baseScoutingData = {
//         scoutingId: item._id,
//         fieldId: field._id,
//         name: field.name,
//         area: field.area,
//         type: field.type,
//         notes: field.notes,
//         createdAt: item.createdAt,
//         startTime: item.startTime,
//         endTime: item.endTime,
//         scoutTimeTaken: item.scoutTimeTaken,
//         growerDetails: item.growerDetails || {},
//         cropStageText: item.cropStageText,
//         cropStageAttachments: item.cropStageAttachments || [],
//         observationNote: item.observationNote,
//         observationAttachments: item.observationAttachments || [],
//         recommendationNote: item.recommendationNote,
//         recommendationAttachments: item.recommendationAttachments || [],
//         sheetAttachments: item.sheetAttachments || [],
//         lld1: field?.lld1 || null,
//         lld2: field?.lld2 || null,
//         lld3: field?.lld3 || null,
//         lld4: field?.lld4 || null,
//         lld5: field?.lld5 || null,
//         lld6: field?.lld6 || null,
//       };

//       if (field.type === 1) {
//         // Type 1 - Single field, no subfields
//         return {
//           ...baseScoutingData,
//           subfieldId: field.subfield?.[0]?._id || null,
//           cropName: field.subfield?.[0]?.cropName || "N/A",
//           cropId: field.subfield?.[0]?.cropId || null,
//           subFields: [],
//         };
//       } else if (field.type === 2) {
//         // Type 2 - Multiple subfields
//         return {
//           ...baseScoutingData,
//           subFields:
//             field.subfield?.map((sub) => ({
//               _id: sub._id,
//               name: sub.name,
//               cropId: sub.cropId,
//               fieldId: sub.fieldId,
//               createdAt: sub.createdAt,
//               cropName: sub.cropName,
//             })) || [],
//         };
//       }

//       return null;
//     })
//     .filter(Boolean); // Remove null values
// };

const convertDate = (dateStr) => {
  const date = new Date(dateStr);
  const formattedDate = date.toLocaleDateString("en-GB");

  return formattedDate;
};

const yearsOptions = () => {
  const currentYear = new Date().getFullYear(); // Get the current year
  const years = [];

  // Add the current year and the next 10 years to the list
  for (let i = 0; i <= 10; i++) {
    years.push(currentYear + i);
  }

  return years;
};
// testing
const transformData = (input) => {
  return input.map((item) => {
    return {
      fieldName: "",
      fieldData: item.fieldData || "",
      fieldArea: item.acresValue,
      description: item.description || "",
      cropName: item.cropName,
      cropId: item.cropId,
      variety: item.variety,
      soilData: {
        nitrogen: item.soilTest.N || "",
        phosphorus: item.soilTest.P || "",
        potassium: item.soilTest.K || "",
        other: item.soilTest.S || "",
      },
      seedData: {
        title: "Seed",
        variety: item?.seed?.variety,
        rate: item?.seed?.rate,
        unit: item?.seed?.unit,
        quantity: item?.seed?.quantity,
      },
      fertility: item.fertility.map((fertility) => ({
        placement: fertility.placement || "",
        actualTotalValue: fertility.actualTotalValue || "0-0-0-0",
        products: fertility.products.map((product) => ({
          productNitrogen: product.soilTest.N || "",
          productPhosphorus: product.soilTest.P || "",
          productPotassium: product.soilTest.K || "",
          productOther: product.soilTest.S || "",
          rate: product.rate || "",
          actualValue: product.actualValue || "0-0-0-0",
        })),
      })),
      totalFertilizerNutrients: item.totalFertilizerNutrients || "",
      totalNutrients: item.totalNutrients || "",
      cropProtection: item.cropProtection.map((crop) => ({
        cropTitle: crop.cropTitle,
        cropDetail: crop.cropDetail.map((cd) => ({
          productId: cd.productId || "",
          productName: cd.productName || "",
          rate: cd.rate || "",
          rateUnit: cd.rateUnit || "",
          notes: cd.notes || "",
          containerSize: cd?.containerSize || "",
          containerUnit: cd?.containerUnit || "L",
          containerType: cd?.containerType || "",
        })),
      })),
    };
  });
};
const UseDebounce = (value, delay = 700) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounced(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debounced;
};

const transformCropPlanData = (apiResponse) => {
  return {
    data: apiResponse.cropPlanList.map((cropPlan) => ({
      fieldId: cropPlan.fieldData?.map((field) => field._id) || [],
      cropName: cropPlan.cropName,
      fieldData: cropPlan.fieldData || [],
      subFieldIds:
        cropPlan.fieldData?.flatMap((field) =>
          field.subFields?.map((sub) => sub._id)
        ) || [],
      cropId: cropPlan.cropId,
      variety: cropPlan.variety,
      acres: cropPlan.fieldData?.length === 0 ? "Values" : "Fields",
      acresValue: cropPlan.fieldArea,
      description: cropPlan.description,
      soilTest: {
        N: cropPlan.soilData?.nitrogen || "",
        P: cropPlan.soilData?.phosphorus || "",
        K: cropPlan.soilData?.potassium || "",
        S: cropPlan.soilData?.other || "",
      },
      fertility:
        cropPlan.fertility?.map((fert) => ({
          placement: fert.placement,
          actualTotalValue: fert.actualTotalValue || "0-0-0-0",
          products: fert.products?.map((product) => ({
            soilTest: {
              N: product.productNitrogen || "",
              P: product.productPhosphorus || "",
              K: product.productPotassium || "",
              S: product.productOther || "",
            },
            rate: product.rate || "",
            rateUnit: product.rateUnit || "",
            actualValue: product.actualValue || "0-0-0-0",
          })) || [
              {
                soilTest: { N: "", P: "", K: "", S: "" },
                rate: "",
                actualValue: "0-0-0-0",
              },
            ],
        })) || [],
      totalFertilizerNutrients: cropPlan.totalFertilizerNutrients,
      totalNutrients: cropPlan.totalNutrients,
      cropProtection:
        cropPlan.cropProtection?.map((protection) => ({
          cropTitle: protection.cropTitle,
          cropDetail:
            protection.cropDetail?.map((detail) => ({
              productId: detail.productId,
              productName: detail.productName,
              rate: detail.rate,
              rateUnit: detail.rateUnit,
              notes: detail.notes,
              containerSize: detail.containerSize || "",
              containerUnit: detail.containerUnit || "L",
              containerType: detail.containerType || "",
            })) || [],
        })) || [],
      seed: {
        variety: cropPlan.seedData?.variety || "",
        rate: cropPlan.seedData?.rate || "",
        rateUnit: cropPlan.seedData?.rateUnit || "",
        unit: cropPlan.seedData?.unit || "",
        quantity: cropPlan.seedData?.quantity || "",
      },
    })),
  };
};

export {
  numberOnly,
  truncateText,
  uniqueIdGenerator,
  multiSelectCustomStyle,
  FiledProcessData,
  convertDate,
  yearsOptions,
  transformData,
  truncateWords,
  // scoutingProcessData,
  ScoutingFiledProcessData,
  UseDebounce,
  transformCropPlanData,
};
